/**
 * Non-security identifiers for blocks, sections and messages.
 *
 * These are for local uniqueness only (React keys, scroll anchors). They are NOT
 * used for session security — opaque session ids and room codes are generated
 * server-side with a cryptographic source (see apps/server).
 */
let counter = 0;
/** Short, locally-unique id such as `blk_lyz3k1_4`. */
export function genId(prefix) {
    counter = (counter + 1) % 1_000_000;
    const time = Date.now().toString(36);
    const rand = Math.floor(Math.random() * 1e9).toString(36);
    return `${prefix}_${time}${rand}${counter.toString(36)}`;
}
/** Ambiguity-free alphabet for human-typed room codes (no 0/O, 1/I/L). */
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
/**
 * Build a room code from a supplied random-byte source. Pure and testable:
 * the caller provides randomness (crypto on the server) so this has no ambient
 * dependency on any RNG.
 */
export function makeRoomCode(randomBytes, length = 6) {
    let out = '';
    for (let i = 0; i < length; i += 1) {
        const byte = randomBytes[i % randomBytes.length] ?? 0;
        out += ROOM_CODE_ALPHABET[byte % ROOM_CODE_ALPHABET.length];
    }
    return out;
}
//# sourceMappingURL=ids.js.map